import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../interfaces/dialog/dialog-params';
import {NgOptimizedImage} from '@angular/common';
import {TranslationDomain} from '../../../../models/translation/translation-domain';
import {LangService} from '../../../../services/language/lang.service';
import {DropdownSelectComponent} from '../../../layout/dropdown-select/dropdown-select.component';
import {
  DropdownSelectOptionComponent
} from '../../../layout/dropdown-select-option/dropdown-select-option.component';
import {FormsModule} from '@angular/forms';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {BotPromptService} from '../../../../services/bot-prompt/bot-prompt.service';
import {BotPrompt} from '../../../../models/bot-prompt';
import {OpenAiRate} from '../../../../models/open-ai/open-ai-rate';
import {BigNumberPipe} from '../../../../pipes/number/big-number.pipe';
import {BotStatus} from '../../../../types/bot-status';

@Component({
  selector: 'app-translation-message-list-translate',
  imports: [
    NgOptimizedImage,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    FormsModule,
    BigNumberPipe
  ],
  templateUrl: './translation-message-list-translate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-message-list-translate.component.scss'
})
export class TranslationMessageListTranslateComponent implements Dialog, OnDestroy {
  translationDomain: TranslationDomain | null = null;
  availableLocales: string[] = [];
  botPrompts: BotPrompt[] = [];

  locked: boolean = false;
  rates: OpenAiRate | null = null;

  selectedBotPrompt: BotPrompt | null = null;
  targetLocale: string | null = null;
  overwrite: boolean = false;

  private interval?: number;

  constructor(
    protected langService: LangService,
    private dialog: DialogService,
    private botPromptService: BotPromptService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.translationDomain = params.data.translationDomain;
    this.translationDomain?.getToLocales().forEach((domainLocale) => {
      if (domainLocale?.locale) {
        this.availableLocales.push(domainLocale.locale);
      }
    });
    this.botPromptService.findAll({sort: 'name'}).subscribe((botPrompts: BotPrompt[]) => {
      this.botPrompts = botPrompts;
    });

    this.interval = setInterval(() => {
      this.getRates();
    }, 2000);
  }

  getRates(): void {
    const parameters: any = {};
    if (this.translationDomain?.domain) {
      parameters.domain = this.translationDomain.domain;
    }
    if (this.targetLocale) {
      parameters.locale = this.targetLocale;
    }

    this.botPromptService.getStatus(parameters).subscribe((status: BotStatus) => {
      this.rates = status.rates;
      this.locked = status.locked;
    });
  }

  getAvailableLocales(): string[] {
    return this.availableLocales ?? [];
  }

  close(): void {
    this.clear();
    this.dialog.closeDialog();
  }

  translate(): void {
    this.clear();

    this.dialog.closeDialog({
      targetLocale: this.targetLocale,
      overwrite: this.overwrite,
      botPromptId: this.selectedBotPrompt?.id ?? null,
    });
  }

  ngOnDestroy(): void {
    this.clear();
  }

  clear(): void {
    if (this.interval !== undefined) {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }
  }
}
